export default __webpack_public_path__ + "static/media/header-new-2.3c813496.png";